import { render } from "./MarketingInsightsPage.vue?vue&type=template&id=3f42e238"
import script from "./MarketingInsightsPage.vue?vue&type=script&lang=js"
export * from "./MarketingInsightsPage.vue?vue&type=script&lang=js"

import "./MarketingInsightsPage.vue?vue&type=style&index=0&id=3f42e238&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__